import React, { useState } from "react";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import { useDroppable } from "@dnd-kit/core";

const Container = ({ id, children, title, description, onAddItem }) => {
  const [query, setQuery] = useState("");
  const handleSearch = (e) => {};
  const { setNodeRef } = useDroppable({ id });
  return (
    <>
      <div className="assignMainHeader">{title}</div>
      <div className="sub-container">
        <div className="container-search">
          <Searchbar
            style="search search-dark input-group"
            path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
            placeholder="Search"
            value={query}
            onChange={handleSearch}
          />
        </div>
        <div className="h-100" ref={setNodeRef}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Container;
